const PHOTO_SCAN_TYPES_LIST_DATA = {
  titleData: {
    textList: [
      {
        id: 1,
        text: '',
        textMob: '',
        secondText: 'All Types of Photos & Slides',
        secondTextMob: 'All Types of',
        isTextReverse: false,
        isTextReverseMob: false,
        isTextColumn: false,
        isTextColumnMob: false,
        isLeft: true,
        isLeftMob: true,
        isRight: false,
        isRightMob: false,
        color: '#fff',
        colorMob: '#fff',
        isTextWithLine: false,
        isTextWithLineMob: false,
        isSecondTextWithLine: true,
        isSecondTextWithLineMob: true,
        firstTextLines: [],
        secondTextLines: [{
          id: 1,
          isLeftLine: false,
          isRightLine: true,
          isTopLine: false,
          isBottomLine: false,
          color: '#fff',
          isLineWithSquare: true,
          isLeftLineMob: false,
          isRightLineMob: true,
          isTopLineMob: false,
          isBottomLineMob: false,
          colorMob: '#fff',
          isLineWithSquareMob: true,
        }],
      },
      {
        id: 2,
        text: 'Digitized to HD Digital.',
        textMob: 'Photos & Slides.',
        secondText: '',
        secondTextMob: '',
        isTextReverse: false,
        isTextReverseMob: false,
        isTextColumn: false,
        isTextColumnMob: false,
        isLeft: false,
        isLeftMob: true,
        isRight: true,
        isRightMob: false,
        color: '#fff',
        colorMob: '#fff',
        isTextWithLine: true,
        isTextWithLineMob: false,
        isSecondTextWithLine: false,
        isSecondTextWithLineMob: false,
        firstTextLines: [{
          id: 1,
          isLeftLine: true,
          isRightLine: false,
          isTopLine: false,
          isBottomLine: false,
          color: '#fff',
          isLineWithSquare: false,
          isLeftLineMob: false,
          isRightLineMob: true,
          isTopLineMob: false,
          isBottomLineMob: false,
          colorMob: '#5F8AA4',
          isLineWithSquareMob: true,
        }],
        secondTextLines: [],
      },
    ],
  },
  typesList: [
    {
      id: 1,
      title: 'Loose Photos',
      description: 'Professionally scan your loose printed photos to high-resolution digital files.',
      image: '',
      imageMob: '',
      link: '',
    },
    {
      id: 2,
      title: '35mm Slides',
      description: 'Convert your 35mm slides to vibrant digital images with exceptional clarity.',
      image: '',
      imageMob: '',
      link: '',
    },
    {
      id: 3,
      title: 'Film Negatives',
      description: 'Digitize your film negatives and rediscover the memories captured within.',
      image: '',
      imageMob: '',
      link: '',
    },
    {
      id: 4,
      title: 'Document Scanning',
      description: 'Preserve important documents with professional high-resolution scanning.',
      image: '',
      imageMob: '',
      link: '',
    },
    {
      id: 5,
      title: 'Photo Albums',
      description: 'Digitize entire photo albums page by page with meticulous care and quality.',
      image: '',
      imageMob: '',
      link: '',
    },
  ],
};

export default PHOTO_SCAN_TYPES_LIST_DATA;
